import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { InduccionEstado, ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { FilterInduccionesPorPersonaModel } from 'src/app/models/induccion/FilterInduccionesPorPersonaModel';
import { PersonaInduccionResultadoModel } from 'src/app/models/induccion/PersonaInduccionResultadoModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { InduccionService } from 'src/app/services/induccion/induccion.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { SedeService } from 'src/app/services/sede/sede.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-induccion-personas-lista',
  templateUrl: './induccion-personas-lista.component.html',
  styleUrls: ['./induccion-personas-lista.component.css']
})
export class InduccionPersonasListaComponent implements OnInit {
  modelFilter: FilterInduccionesPorPersonaModel;
  modelListaPersonas: PersonaInduccionResultadoModel[];
  listaEstadoInducciones: ParametroModel[];
  listaSedes: ISedeModel[] = new Array<SedeModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  resultsLength = 0;
  currentPage = 0;

  @ViewChild('paginator') paginator!: MatPaginator;
  
  displayedColumns: string[] = [
    'compania',
    //'codigo_solicitud',
    'contratista',
    'nombreSede',
    //'solicitante',
    'trabajador',
    'nroDocumentoIdentidad',
    'fecha_induccion',
    'capacitador',
    'estado'
  ];

  constructor(
    private induccionService: InduccionService,
    private parametroService: ParametroService,
    private storage: StorageService,
    private sedeService: SedeService
  ) { 
    this.modelListaPersonas = [];
    this.modelFilter = new FilterInduccionesPorPersonaModel();
    this.modelFilter.pageSize = 30;
    this.modelFilter.estados = [InduccionEstado.PROGRAMADO, InduccionEstado.APROBADO, InduccionEstado.RECHAZADO, InduccionEstado.VENCIDO, InduccionEstado.SUSPENDIDO];
    
    let usuario = this.storage.getCurrentUser();
    this.listaCompanias = usuario.companias;
    this.modelFilter.idCompania =  usuario.companiaDefault.idCompania;
    this.listaEstadoInducciones = new Array<ParametroModel>();
  }

  ngOnInit(): void {
    this.companiaChanged();
    this.parametroService
      .getDetalles(ParametrosMaestro.EstadosInducciones)
      .subscribe((data: SearchResultModel<ParametroModel[]>) => {
        this.listaEstadoInducciones = data.items.filter(p => p.idParametroDetalle != InduccionEstado.EMPTY && p.idParametroDetalle != InduccionEstado.PENDIENTE)
      });
      this.search();
  }

  companiaChanged() {

    this.listaSedes = [];
    this.modelFilter.sedes = [];
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.modelFilter.idCompania);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });
  }

  getPaginatorData(event: any) {
    this.modelFilter.page = event.pageIndex + 1;
    this.modelFilter.pageSize = event.pageSize;
    this.induccionService
      .getListInduccionesPorPersona(this.modelFilter)
      .subscribe((data: SearchResultModel<PersonaInduccionResultadoModel[]>) => {
        this.modelListaPersonas = data.items;
        this.resultsLength = data.total;
      });
  }

  search() {
    //this.paginator.pageIndex = 0;
    this.modelFilter.page = 1;
    
    this.induccionService
      .getListInduccionesPorPersona(this.modelFilter).subscribe((data) => {
        this.modelListaPersonas = data.items;

        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  keyPressNumberOnly(event: any) {
    const pattern = /^[0-9]*$/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  addDays(currentDate: Date, days : number): Date{
    currentDate.setDate(currentDate.getDate() + days);
    return currentDate;
  }
}
